import React, { Fragment } from "react";
import styled from "styled-components";
import { Typography } from "@mui/material";
import { entrezConfig } from "../../app/util/entrezConfig";

import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { useTable, useSortBy } from "react-table";

// import ToolTip from "react-tooltip";
import { Link } from "@mui/material";
import TitleSecondary from "../../app/components/TitleSecondary";
import CustomToolTip from "./CustomToolTip";
const Styles = styled.div`
  padding: 1rem;
  table {
    border-spacing: 0;
    border: 1px solid gray;
    // margin: 60px 0px 10px 0px;
    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    tr {
      :nth-child(even) {
        // background-color: #f2f2f2;
      }
    }

    th {
      border: 1px solid gray;
      // border-collapse: collapse;
      //border-right: 1px solid red;
      //  background-color: #4278f5;
      color: white;
    }
    td {
      margin: 0;
      padding: 0.5rem;
      border: 1px solid gray;
      //border-right: 1px solid red;
      :last-child {
        border-right: 0;
      }
    }
    // to hide the header row which is being added by react-table.
    thead tr:first-child {
      display: none;
      // background-color: red;
    }
  }

  .form-control {
    min-width: 100%;
    max-width: 100%;
  }

  .pagination {
    padding: 1rem;
  }
`;

// Library we used here:
// https://react-table.tanstack.com/docs/api/useTable
//
function TableCustom({ columns, data, selectedDB }) {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
      },
      useSortBy
    );

  //const ccdbRecords = React.useMemo(() => getCCDBData(), []);
  // const downloadData = data.map((d) => Object.values(d));

  var link =
    entrezConfig.NCBLinks[selectedDB] === undefined
      ? entrezConfig.NCBIDefaultLInk + "/" + selectedDB
      : entrezConfig.NCBLinks[selectedDB];

  return (
    <Fragment>
      {/* <CSVLink data={downloadData}>Download me</CSVLink> */}
      {/* <GlobalFilter
        preGlobalFilteredRows={preGlobalFilteredRows}
        globalFilter={state.globalFilter}
        setGlobalFilter={setGlobalFilter}
      /> */}

      <TableContainer  sx={{ maxHeight: 3500 }}>
        {/* Table  --  //auto  -- is for scrollable,   fixed  -- for responsive*/}
        <Table
          className="table1"
          sx={{ tableLayout: "auto" }}
          {...getTableProps()}
        >
          <TableHead
            sx={{
              backgroundColor: "primary.main",
            }}
          >
            {headerGroups.map((headerGroup) => (
              <TableRow {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <TableCell
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    <>
                      <CustomToolTip
                        keyValue={column.render("Header").toUpperCase()}
                      >
                        <Typography variant="subtitle2">
                          {column.render("Header")}
                        </Typography>
                      </CustomToolTip>
                      {/* <ToolTip place="right" id={this.accessor}>
                      My tooltip
                    </ToolTip> */}
                    </>
                    {/* Add a sort direction indicator */}
                    {/* <span>
                    {
                      column.isSortedDesc ? " 🔽" : " 🔼"
                     }
                  </span> */}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? " 🔽"
                          : " 🔼"
                        : ""}
                    </span>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableHead>

          {/* moved the code for each column filter outside the component - means commented */}

          {/* finally the data row */}
          <TableBody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <TableRow
                  {...row.getRowProps()}
                  sx={{
                    "&:hover": {
                      backgroundColor: "#d9d9d9",
                    },
                  }}
                >
                  {row.cells.map((cell) => {
                    var isUID = cell.column.Header === "uid";
                    //var getWidth = isUID ? 12 : 20;
                    return (
                      <TableCell
                        // sx={{ width: getWidth }}
                        {...cell.getCellProps()}
                      >
                        {isUID && (
                          <Link
                            href={`${link}/${cell.value}`}
                            target="_blank"
                            rel="noreferrer"
                            color="secondary.main"
                          >
                            {" "}
                            {cell.render("Cell")}{" "}
                          </Link>
                        )}

                        {!isUID && (
                          <Typography variant="body2">
                            {cell.render("Cell")}
                          </Typography>
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Fragment>
  );
}

export default function DBTableView({
  dbRecords,
  selectedDB,
  selectedColumns,
}) {
  const columns = [
    {
      Header: "CCDB",
      columns: dbRecords.dbColumns.filter((col) =>
        selectedColumns.includes(col.Header)
      ),
    },
  ];

  return (
    <Styles>
      <>
        <TableCustom
          columns={columns}
          data={dbRecords.dbRows}
          selectedDB={selectedDB}
        />
      </>
    </Styles>
  );
}

// {/* Add the filter for each column */}
//           {/* <TableHead>
//             {headerGroups.map((headerGroup) => (
//               <TableRow {...headerGroup.getHeaderGroupProps()}>
//                 {headerGroup.headers.map((column) => (
//                   <TableCell {...column.getHeaderProps()}>
//                     {/* {column.render("Header")} */}
//                     {/* {/* Render the columns filter UI */}
//                     {column.canFilter ? column.render("Filter") : null}
//                   </TableCell>
//                 ))}
//               </TableRow>
//             ))}
//           </TableHead> */}

// const columns = React.useMemo(
//   () => [
//     {
//       Header: "CCDB",
//       columns: [
//         {
//           Header: "S.No",
//           accessor: "sNumber",
//         },
//         {
//           Header: "PMID",
//           accessor: "uid",
//           Cell: (e) => (
//             <a
//               href={"https://pubmed.ncbi.nlm.nih.gov/" + e.value}
//               target="_blank"
//               rel="noreferrer"
//             >
//               {" "}
//               {e.value}{" "}
//             </a>
//           ),
//         },

//         // {
//         //   Header: "Source",
//         //   accessor: "source",
//         // },
//         {
//           Header: "Title",
//           accessor: "title",
//         },
//         // {
//         //   Header: "Pub Date",
//         //   accessor: "pubdate",
//         // },

//         {
//           Header: "Author",
//           accessor: "authors",
//         },
//         {
//           Header: "Location ID",
//           accessor: "elocationid",
//         },
//       ],
//     },
//   ],
//   []
// );
